import { Action } from '@ngrx/store';
import { BasicDeal } from '../../types/deal.types';
import {
  MaturityAnalyticsColumnName,
  CalendarGridColumnName
} from '../../grid/types/column.types';
import { FilterSet } from '../../types/user-preferences.types';

export enum CalendarActionTypes {
  LoadCalendar = '[Calendar] Load',
  LoadCalendarSuccess = '[Calendar] Load Success',
  LoadCalendarFail = '[Calendar] Load Fail',
  UpdateDeals = '[Calendar] Update Deals',
  UpdateDealsSuccess = '[Calendar] Update Deals Success',
  UpdateDealsFail = '[Calendar] Update Deals Fail',
  UpdateWeekOf = '[Calendar] Update Week Of',
  SetFlexColumn = '[Calendar] Set Flex Column',
  SetMaturityAnalyticsColumn = '[Calendar] Set Maturity Analytics Column',
  RemoveMaturityAnalyticsColumn = '[Calendar] Remove Maturity Analytics Column',
  SetSavedFilter = '[Calendar] Set Saved Filters'
}

export class LoadCalendar implements Action {
  public readonly type = CalendarActionTypes.LoadCalendar;
}

export class UpdateDeals implements Action {
  public readonly type = CalendarActionTypes.UpdateDeals;

  constructor(public payload: { weekOf: string; dealIds: string[] }) {}
}

export class UpdateDealsSuccess implements Action {
  public readonly type = CalendarActionTypes.UpdateDealsSuccess;
  constructor(public payload: BasicDeal[]) {}
}

export class UpdateDealsFail implements Action {
  public readonly type = CalendarActionTypes.UpdateDealsFail;
  constructor(public payload: string) {}
}

export class LoadCalendarSuccess implements Action {
  public readonly type = CalendarActionTypes.LoadCalendarSuccess;

  constructor(public payload: BasicDeal[]) {}
}

export class LoadCalendarFail implements Action {
  public readonly type = CalendarActionTypes.LoadCalendarFail;

  constructor(public payload: string) {}
}

export class UpdateWeekOf implements Action {
  public readonly type = CalendarActionTypes.UpdateWeekOf;

  constructor(public payload: string) {}
}

export class SetFlexColumn implements Action {
  public readonly type = CalendarActionTypes.SetFlexColumn;

  constructor(public payload: CalendarGridColumnName) {}
}

export class SetMaturityAnalyticsColumn implements Action {
  public readonly type = CalendarActionTypes.SetMaturityAnalyticsColumn;

  constructor(public payload?: MaturityAnalyticsColumnName) {}
}

export class RemoveMaturityAnalyticsColumn implements Action {
  public readonly type = CalendarActionTypes.RemoveMaturityAnalyticsColumn;
}

export class SetSavedFilter implements Action {
  public readonly type = CalendarActionTypes.SetSavedFilter;

  constructor(public payload?: FilterSet) {}
}

export type CalendarActionUnion =
  | LoadCalendar
  | LoadCalendarSuccess
  | LoadCalendarFail
  | UpdateDeals
  | UpdateDealsSuccess
  | UpdateDealsFail
  | UpdateWeekOf
  | SetFlexColumn
  | SetMaturityAnalyticsColumn
  | RemoveMaturityAnalyticsColumn
  | SetSavedFilter;
